module.exports = __webpack_public_path__ + "img/n_zuji_off.e9238729.png";